import {
  Image,
  Text,
  HorizontalStack,
  Icon,
} from "@shopify/polaris";

import InstagramSvg from '../assets/Instagram.svg'
import YoutubeSvg from '../assets/Youtube.svg'
import TiktokSvg from '../assets/Tiktok.svg'
import { BehaviorMajor } from "@shopify/polaris-icons";

export function numberToUSD(num) {
  if (!num && num !== 0) return num;
  const res = Number(num).toLocaleString('en-us', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  })
  return res
}

export function Instagram({ width }) {
  return <Image source={InstagramSvg} height={width || "20"} alt="Instagram" />
}

export function Youtube({ width }) {
  return <Image source={YoutubeSvg} height={width || "20"} alt="Youtube" />
}

export function Tiktok({ height = "15" }) {
  return <Image source={TiktokSvg} height={height} alt="Tiktok" />
}
function getFlagEmoji(countryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

export function getCountry(country) {
  if (!country) return country;
  return `${getFlagEmoji(country)} ${country.toUpperCase()}`;
}

export function copyToClipboard(url, setToasts) {
  try {
    navigator.clipboard.writeText(url)
    setToasts([{ msg: 'Copied to clipboard', type: 'success' }])
  } catch (e) {
    setToasts([{ msg: 'Failed to copy to clipboard', type: 'error' }])
  }
}

export function getBestAvatar(creator) {
  return creator?.profile?.profile?.picture
}

export function shortenNumber(number) {
  if (!number || typeof number !== 'number' || number < 1000) return number
  return (number > 1000000) ? (number / 1000000)?.toFixed(2) + 'M' : Math.floor(number / 1000) + 'K'
}

export function formatStringForDB(string) {
  if (!string) return string
  return string.trim().replaceAll('\n', '\\n')
}

export function formatStringForUI(string) {
  if (!string) return string
  return string.replaceAll('\\n', '\n')
}

export const contentFormats = [
  {
    label: 'Instagram Post(s)', value: 'instagramPost', icon: <Instagram />
  },
  {
    label: 'Short(s)', value: 'short', icon: <HorizontalStack blockAlign="center"><Instagram /> <Tiktok /></HorizontalStack>
  },
  {
    label: 'Youtube Video(s)', value: 'youtubeVideo', icon: <Youtube />
  },
  {
    label: 'Bundle / Multiple', value: 'bundle', icon: <HorizontalStack blockAlign="center"><Instagram /> <Tiktok /> <Youtube /></HorizontalStack>
  }
]

export function getContentFormat(formatRaw) {
  const format = contentFormats.find(format => format.value === formatRaw);
  return <HorizontalStack gap="1">
    {
      format?.icon || <Icon source={BehaviorMajor} />
    }
    <Text>{format?.label || formatRaw}</Text>
  </HorizontalStack>
}
